const currencyFormatter = new Intl.NumberFormat('en-US', {
    // style: 'currency',
    // currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

export const ReceivablesGridHeader = [
    { field: 'rowNumber', headerName: '#', width: 70, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'InvoiceNr', headerName: 'Numri i Akëtimit', width: 130, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'Date', headerName: 'Data', width: 120, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'AccountName', headerName: 'Emri Klientit', width: 260, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    { field: 'LedgerName', headerName: 'Llogaria', width: 120, editable: false, headerClassName: 'super-app-theme--header', groupable: false, aggregable: false },
    {
        field: 'Total', headerName: 'Vlera', type: 'string', width: 150, editable: false, headerClassName: 'super-app-theme--header', groupable: true,
        valueFormatter: (value) => {
            if (!value) {
                return value;
            }
            return currencyFormatter.format(value);
        },
    },
]

